import { computed, makeObservable, observable } from 'mobx'

class PricingRangeStore {
  @observable name
  @observable from
  @observable to

  constructor (data) {
    makeObservable(this)
    Object.assign(this, data)
  }

  @computed get active () {
    return Boolean(this.from !== undefined && this.from !== null)
  }
}

export default PricingRangeStore
